@keyframes folderEnumBarEnter {
	from {
		opacity: 0;
		transform: translateY(4px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes folderEnumSegmentFade {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

.folderEnumBar {
	position: relative;
}

.folderEnumBarAnimated {
	animation: folderEnumBarEnter 0.42s ease-out both;
}

.folderEnumBarSegment {
	align-items: center;
	display: flex;
	flex: none;
	height: 100%;
	justify-content: center;
	min-width: 0;
	overflow: hidden;
	position: relative;
}

.folderEnumBarSegmentAnimated {
	animation: folderEnumSegmentFade 0.38s ease-out both;
}

.folderEnumBarRemainder {
	flex: none;
}

.folderEnumBarRemainderAnimated {
	animation: folderEnumSegmentFade 0.38s ease-out both;
}

.folderEnumBarLabel {
	color: #fff;
	font-size: 0.8rem;
	font-weight: 700;
	line-height: 1;
	pointer-events: none;
	text-shadow:
		0 0 1px rgb(0 0 0 / 0.9),
		0 1px 2px rgb(0 0 0 / 0.55);
	white-space: nowrap;
}
